module.exports = __webpack_public_path__ + "img/avatar2.12ae26a.svg";